import React, { useState } from "react";
import { useDispatch } from "react-redux";
import AuthLayout from "../customComponent/AuthLayout";
import SuccessBackground from "../../asesst/SuccessBackground.svg";
import Tick from "../../asesst/tick.svg";
import { resetPassword } from "../../redux/action/Auth/ForgetPasswordAction";
import { Box, Modal } from "@mui/material";

const ResetLink = () => {
  const dispatch = useDispatch();
  const [modalVisible, setModalVisible] = useState(false);

  const handleResendClick = async () => {
    try {
      const email = localStorage.getItem("resetPasswordEmail");
      if (email) {
        await dispatch(resetPassword(email));
        setModalVisible(true);
      } else {
        alert("Email not found. Please try the forget password process again.");
      }
    } catch (error) {
      alert("Failed to resend reset link. Please try again.");
    }
  };

  const ResetLinkSent = () => (
    <div className="bg-white p-2 rounded-lg flex items-center space-x-6">
      <div
        className="w-[72px] h-[72px] flex items-center justify-center"
        style={{ backgroundImage: `url(${SuccessBackground})` }}
      >
        <img src={Tick} alt="Success" className="w-7 h-7" />
      </div>
      <p className="text-gray-500 font-semibold">Reset Link Sent</p>
    </div>
  );

  const closeModal = () => setModalVisible(false);
  return (
    <>
      <AuthLayout
        title={<ResetLinkSent />}
        description="Password reset link has been successfully sent to your registered email address."
        footerText={
          <span className="flex">
            <span>Didn't receive the email? </span>
            <span
              className="text-[#1C3664] ml-1 cursor-pointer hover:underline inline"
              onClick={handleResendClick}
            >
              Click here to resend
            </span>
          </span>
        }
      />

      <Modal open={modalVisible} className="justify-center items-center ">
        <Box className="bg-white text-center p-6 rounded-2xl shadow-md max-w-lg mx-auto my-20">
          <div className="text-center inline-flex mt-8">
            <div
              className="w-[72px] h-[72px] flex items-center justify-center"
              style={{ backgroundImage: `url(${SuccessBackground}` }}
            >
              <img src={Tick} alt="Success" className="w-7 h-7" />
            </div>
          </div>
          <p className="text-3xl text-[#0B0B0B] font-semibold mt-4 mb-4">
            Success
          </p>
          <span className="text-[#6D6D6D]">Reset link sent successfully!</span>
          <div className="mt-6 flex justify-center gap-4">
            <button
              onClick={closeModal}
              className="border border-inherit px-4 py-2 rounded-lg"
            >
              Close
            </button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default ResetLink;
